import { FormattedMessage } from 'react-intl';
import { routes } from '@/shared/routes';

export default function ExternalBackLink() {
  return (
    <a
      href={routes.root}
      className="inline-flex items-center gap-1 rounded-full px-2 py-1 text-sm font-semibold text-brand-700 hover:bg-slate-100 hover:text-brand-600"
    >
      <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
      </svg>
      <FormattedMessage id="auth.signIn.backToWebsite" />
    </a>
  );
}
